import { axios } from '@/lib/axios';

export type ConsumeConfirmationCredentials = {
  confirmationToken: string;
  redirectUrl: string | null;
};

export type ConsumeConfirmationResponse = {
  redirectUrl: string;
};

export const consumeConfirmation = async (
  data: ConsumeConfirmationCredentials
): Promise<ConsumeConfirmationResponse> => {
  return axios.post('/api/v1/auth/confirmation/consume', data);
};
